import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UserService } from '../service/user.service';
import { Router, NavigationStart  } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {

  username:any;
  userId:any;
  availableCredits:any;
  usedCredits:any;
  credits:any;
  getRCSCredits:any;

  constructor(
    public popoverController: PopoverController,
    private userService:UserService,
    private router: Router
  ) { }

  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.userId = localStorage.getItem('id');
    this.getCredits();
  }

  getCredits(){
    this.userService.getUserwiseCredit(this.userId).subscribe(response=>{
      this.credits=response;
      this.availableCredits = response.availableCredits;
      this.usedCredits=response.usedCredits;
      this.getRCSCredits=response.rcsAvailableCredits;
    })
  }

  async DismissClick() {
    await this.popoverController.dismiss();
      }

  logOut() {
    localStorage.clear();
    localStorage.removeItem('id');
    localStorage.removeItem('username');
    localStorage.removeItem('password');
    this.router.navigateByUrl('/', { replaceUrl: true }).then(() => {
      window.location.reload(); // Optional, adds extra security
    });
  }

  account(){
    this.router.navigateByUrl('/user/account');
    this.popoverController.dismiss();
  }

}
